import { Center, Text } from '@mantine/core';
import { Loader } from 'src/design/atoms/Loader';

export interface IPdfViewerProps {
  src: string | null;
  title: string;
  loading?: boolean;
  height?: number | string;
  emptyText?: string;
}

/** @registry Renders a PDF in an <iframe> over a blob/object URL; pair with usePdfBlobUrl to view fetched PDF bytes. Shows a loader while fetching and a fallback message when no source is set. */
export const PdfViewer: React.FC<IPdfViewerProps> = ({
  src,
  title,
  loading = false,
  height = '75vh',
  emptyText = 'No PDF to display.',
}) => {
  if (loading) {
    return (
      <Center h={height}>
        <Loader />
      </Center>
    );
  }

  if (!src) {
    return (
      <Center h={height}>
        <Text c="dimmed" size="sm">
          {emptyText}
        </Text>
      </Center>
    );
  }

  return (
    <iframe
      title={title}
      src={src}
      style={{ width: '100%', height, border: 'none' }}
    />
  );
};
